<div class="btn-group" dropdown placement="bottom right">
	<button
		title="Notifications"
		dropdownToggle
		type="button"
		class="btn nav-link"
		(click)="resetNotificationNumber()"
	>
		<i class="bi bi-bell topbar-blue-button" aria-hidden="true"></i>
		<span class="badge rounded-pill">{{
			notificationNumber > 0 ? notificationNumber : ''
		}}</span>
	</button>

	<ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
		<li
			role="alert"
			class="alert alert-light hand-cursor unselectable-text"
			*ngIf="notificationList.length === 0"
		>
			<!-- Flexbox pour positionner l'icône sur la droite, et l'ensemble des éléments au milieux -->
			<div class="d-flex justify-content-between align-items-center">
				<div>
					<strong>Pas de notifications</strong>
				</div>
				<div>
					<i class="bi bi-bell-slash-fill fs-3" aria-hidden="true"></i>
				</div>
			</div>
		</li>

		<li
			role="alert"
			*ngFor="let notification of notificationList"
			[ngClass]="getNotificationDisplayClass(notification)"
			(click)="goToPlanningPage(notification)"
		>
			<!-- Flexbox pour positionner l'icône sur la droite, et l'ensemble des éléments au milieux -->
			<div class="d-flex justify-content-between align-items-center">
				<div>
					<strong>{{ notification.title }}</strong> <br />
					{{ notification.message }}
				</div>
				<div>
					<i
						*ngIf="notification.optimState === 'finished'"
						class="bi bi-calendar-check fs-3"
						aria-hidden="true"
					></i>
					<i
						*ngIf="notification.optimState === 'inProgress'"
						class="bi bi-hourglass-split fs-3"
						aria-hidden="true"
					></i>
					<i
						*ngIf="notification.optimState === 'waiting'"
						class="bi bi-clock fs-3"
						aria-hidden="true"
					></i>
				</div>
			</div>
		</li>
	</ul>
</div>
